import { Chain, ChainType } from '@ankr.com/chains-list';

import { EndpointGroup } from 'modules/endpoints/types';

export enum Feature {
  GRPC_WEB,
  REST,
  RPC,
}

export interface MainEndpointsProps {
  feature?: Feature;
  group: EndpointGroup;
  publicChain: Chain;
  chainType: ChainType;
}
